import type { Message } from '../types/interfaces'

/**
 * Ordena en sitio los mensajes de un chat que puede acumular varias sesiones del mismo
 * número (las que trae `GET /oper/chats/{id}/history`).
 *
 * `consecutive` se reinicia en cada sesión — el backend lo calcula como MAX+1 por
 * `chat_id` — así que ordenar solo por él intercala las conversaciones. El orden entre
 * sesiones se toma de la primera aparición de cada `chat_id` en el array, que es el que
 * ya viene del backend (ordenado por `chats.start_date`).
 */
export const sortChatMessages = (messages: Message[]): Message[] => {
  const sessionOrder = new Map<string, number>()
  for (const message of messages) {
    const sessionId = String(message.chat_id ?? '')
    if (!sessionOrder.has(sessionId)) {
      sessionOrder.set(sessionId, sessionOrder.size)
    }
  }

  return messages.sort((a, b) => {
    const sessionA = sessionOrder.get(String(a.chat_id ?? '')) ?? 0
    const sessionB = sessionOrder.get(String(b.chat_id ?? '')) ?? 0
    if (sessionA !== sessionB) {
      return sessionA - sessionB
    }
    return a.consecutive - b.consecutive
  })
}
